import React from "react";

const CustomCheckmarkIcon: React.FC = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Check line">
      <path
        id="Line 1"
        d="M1.36312 6.49928L4.11997 9.62085L9.92708 2.54203"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default CustomCheckmarkIcon;
